import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

const styles = {
  button: {
    // textShadow: '1px 1px 1px #333',
    margin: "0 0 10px auto",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
};

class HeaderMenu extends Component {
  contructor(props) {
    this.super(props);
  }

  _onClick(e, href) {
    const id = href.replace("/#", "");
    if (["mission"].indexOf(id) < 0) {
      const top = document.getElementById(id)
        ? document.getElementById(id).offsetTop +
          10 -
          document.getElementById("header").offsetHeight
        : false;
      window.scroll({
        top,
        behavior: "smooth",
      });
    }
    if (this.props.onClick) this.props.onClick();
  }
  render() {
    const {
      mode,
      current,
      $$menu,
      classes,
      itemClass,
      itemClassSelected,
      // selected,
    } = this.props;
    // console.log({ current })
    let selected;
    return (
      <React.Fragment>
        {$$menu
          .map((menu, i) => {
            selected = menu.get("icon") === current ? true : false;
            if (menu.get("target") === "_blank")
              return (
                <Button
                  classes={{ root: classes.button }}
                  className={clsx(itemClass, {
                    [itemClassSelected]: selected === true,
                  })}
                  key={"lnk_" + i}
                  aria-label={menu.get("title")}
                  onClick={() => {
                    console.log("clicked!");
                    window.open(menu.get("url"));
                  }}
                  disableRipple
                >
                  {menu.get("title")}{" "}
                </Button>
              );
            else
              return (
                <Button
                  classes={{ root: classes.button }}
                  className={clsx(itemClass, {
                    [itemClassSelected]: selected === true,
                  })}
                  key={"lnk_" + i}
                  aria-label={menu.get("title")}
                  component={Link}
                  to={menu.get("url")}
                  disableRipple
                >
                  {menu.get("title")}{" "}
                </Button>
              );
          })
          .toArray()}
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(HeaderMenu);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderMenu.jsx